<div class="layout-row layout-align-start-center full-height"
     (click)="$event.stopPropagation();">
  <bringoz-icon iconName="location-pin-outline" [fill]="status ? '#4ABF4A': '#FF6B6D'"
                [ngbTooltip]="tooltipTmpl"
                (shown)="getLocation()"
                size="xl"
                openDelay="300"
                triggers="hover"
                container="body"></bringoz-icon>

  <div *ngIf="!loading && showText"
       class="margin-left-5 last-update-container gap-5 layout-row layout-align-start-center">
    <span class="fade-element-in-only last-update" translate>Last seen</span>
    <span class="fade-element-in-only last-update">{{ lastUpdate | bringozTimeAgo }}</span>
  </div>
</div>


<ng-template #tooltipTmpl>
  <div class="agent-location-tooltip layout-column layout-align-start-start br-body-2 font-weight-400 primary-100">

    <div *ngIf="locationTrackingApproval !== undefined">
      <span *ngIf="locationTrackingApproval" translate>Location tracking is enabled. The agent is on duty and has permitted location tracking.</span>
      <span *ngIf="!locationTrackingApproval" translate>Location tracking is disabled. The agent is either off duty or did not permit location tracking.</span>
    </div>

    <div class="layout-row layout-align-start-center">
      <div *ngIf="!!status" class="layout-row layout-align-start-center margin-right-5">
        {{ gpsStatus ? 'GPS service is ON' : 'GPS service is OFF' | translate }}
      </div>

      <div *ngIf="!!gpsPermission" class="layout-row layout-align-start-center">
        {{ 'GPS Permission' | translate }}: {{ 'AGENT_GPS_PERMISSION.' + gpsPermission | translate }}
      </div>
    </div>

    <div *ngIf="showAddress" class="layout-row layout-align-start-center">
      <span *ngIf="loading">{{ 'Loading' | translate }}...</span>
      <div *ngIf="!loading && agentLocationAddress" class="flex layout-row layout-align-start-center">
        <span>{{ "Last location" | translate }}:</span>
        <span class="margin-left-5">{{ agentLocationAddress.place || '---' }}</span>
      </div>
    </div>

    <div class="opacity-60">{{ lastUpdate | bringozTimeAgo }}</div>

  </div>
</ng-template>
